// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2-eJR","cell":"ColumnAccessor_cell__1zKNG","firstCellAccent":"ColumnAccessor_firstCellAccent__1VkM3"};